import { RouteRecordRaw } from 'vue-router';

import { ROUTE_KEYS } from '~/router';

export const SignInRoute: RouteRecordRaw = {
	path: 'sign-in',
	name: ROUTE_KEYS.AUTH_SIGN_IN,
	component: () => import('./components/routes/sign-in.vue')
};

export const SignUpChooseUsernameRoute: RouteRecordRaw = {
	path: 'choose-username',
	name: ROUTE_KEYS.AUTH_SIGN_UP_CHOOSE_USERNAME,
	components: {
		default: () => import('./components/routes/sign-up/sign-up-choose-username.vue'),
		signUpFooter: () => import('./components/routes/sign-up/sign-up-footer.vue')
	}
};

export const SignUpChoosePasswordRoute: RouteRecordRaw = {
	path: 'choose-password',
	name: ROUTE_KEYS.AUTH_SIGN_UP_CHOOSE_PASSWORD,
	components: {
		default: () => import('./components/routes/sign-up/sign-up-choose-password.vue'),
		signUpNav: () => import('./components/auth-nav.vue'),
		signUpFooter: () => import('./components/routes/sign-up/sign-up-footer.vue')
	},
	props: {
		default: true,
		signUpNav: () => ({ goBackRoute: { name: ROUTE_KEYS.AUTH_SIGN_UP_CHOOSE_USERNAME } })
	}
};

export const SignUpSuccess: RouteRecordRaw = {
	path: 'success',
	name: ROUTE_KEYS.AUTH_SIGN_UP_SUCCESS,
	components: {
		default: () => import('./components/routes/sign-up/sign-up-success.vue')
	}
};

export const SignUpRoute: RouteRecordRaw = {
	path: 'sign-up',
	name: ROUTE_KEYS.AUTH_SIGN_UP,
	children: [SignUpChooseUsernameRoute, SignUpChoosePasswordRoute, SignUpSuccess],
	component: () => import('./components/routes/sign-up/sign-up.vue'),
	redirect: () => SignUpChooseUsernameRoute
};

export const ConfirmSignUpRoute: RouteRecordRaw = {
	path: 'confirm-sign-up',
	name: ROUTE_KEYS.AUTH_SIGN_UP_CONFIRM,
	component: () => import('./components/routes/confirm-sign-up.vue'),
	props: true
};

export const ResetPasswordRoute: RouteRecordRaw = {
	path: 'reset-password',
	name: ROUTE_KEYS.AUTH_RESET_PASSWORD,
	component: () => import('./components/routes/reset-password.vue')
};

export const ConfirmResetPasswordRoute: RouteRecordRaw = {
	path: 'confirm-reset-password',
	name: ROUTE_KEYS.AUTH_CONFIRM_RESET_PASSWORD,
	component: () => import('./components/routes/confirm-reset-password.vue')
};

const AuthRoute: RouteRecordRaw = {
	path: '/auth',
	name: ROUTE_KEYS.AUTH,
	component: () => import('./auth.page.vue'),
	redirect: () => SignInRoute,
	children: [SignInRoute, SignUpRoute, ConfirmSignUpRoute, ResetPasswordRoute, ConfirmResetPasswordRoute]
};

export default AuthRoute;
